import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TableContainer, Table, TableBody, TableRow, TableCell } from "@mui/material";
import dayjs from "dayjs";
import ReactPlayer from "react-player";
import { useEnumApi } from "contexts/EnumApiContext";

const EquipmentAlertAndInspectionTable = ({equipmentAlert}) => {
  const { getEnumValueByEnumNameAndCode } = useEnumApi();
  const { t } = useTranslation();
  const [movie, setMovie] = useState(null);

  const playMovie = (diagnosisId) => {
    setMovie(process.env.REACT_APP_API_URL+"/api/download/:direct?fileGroup=DCV&id="+diagnosisId);
  }

  return(
                <>
                  <TableContainer>
                    <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width" style={{borderCollapse:"unset", borderSpacing:"revert"}}>
                      <TableBody>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alertedAt')}</TableCell>
                          <TableCell align="center">{equipmentAlert.latestAlertedAt && dayjs(equipmentAlert.latestAlertedAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alertType')}</TableCell>
                          <TableCell align="center">{equipmentAlert.alertType && getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType) && getEnumValueByEnumNameAndCode("AlertType", equipmentAlert.alertType)[0].title}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alertCategory')}</TableCell>
                          <TableCell align="center">{equipmentAlert.alertCategory && getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory) && getEnumValueByEnumNameAndCode("AlertCategory", equipmentAlert.alertCategory)[0].title}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alertDetail')}</TableCell>
                          <TableCell className="pl" colSpan={3} style={{textAlign:"left",whiteSpace:"pre-line"}}>
                            {equipmentAlert.alertDtl || ''}{equipmentAlert.alertDtl && <br/>}
                            {
                                equipmentAlert.equipmentPartFaultCodes && equipmentAlert.equipmentPartFaultCodes.length > 0 ?
                                equipmentAlert.equipmentPartFaultCodes.map(function(codes, idx) {
                                return (
                            <div key={idx}>
								                {codes.equipmentPart?.masterEquipmentPart?.name}[{codes.equipmentPart?.position}]-
                                {codes.diagnosisCode?.subCategoryNm}({codes.diagnosisCode?.categoryNm})
                                &nbsp;<span className="icon_png" style={{verticalAlign:"middle", cursor:"pointer"}} onClick={()=>{playMovie(codes.diagnosisCode?.code)}}>
                                  <img src={`${process.env.PUBLIC_URL}/img/icon/emergency_recording.png`} alt='' />
                                </span><br />
                            </div> 
                                )
                                })
                                : ""
                            }
                          </TableCell>
                          <TableCell colSpan={2} align="center">
                            {movie && 
                            <div className='player-wrapper' style={{width:'100%'}}>
                              <ReactPlayer
                                className='react-player'
                                url={movie}
                                width='100%'
                                height='100%'
                                playing={true}
                                //muted={true}
                                loop={true}
                              />
                            </div>
                            }
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alert.checkedAt')}</TableCell>
                          <TableCell align="center">{equipmentAlert.chkedAt && dayjs(equipmentAlert.chkedAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.alert.check.user')}</TableCell>
                          <TableCell align="center">{equipmentAlert.chkUser}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.status')}</TableCell>
                          <TableCell>
                            {equipmentAlert && equipmentAlert.status && getEnumValueByEnumNameAndCode("EquipmentAlertStatus", equipmentAlert.status) && 
                            <div className="condition1" /*style={{margin:"unset",marginLeft:"8px"}}*/>{getEnumValueByEnumNameAndCode("EquipmentAlertStatus", equipmentAlert.status)[0].title}</div>}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell className="th" align="center">{t('message.common.subtitle.constantInspection.checkedAt')}</TableCell>
                          <TableCell align="center">{equipmentAlert.fieldChkedAt && dayjs(equipmentAlert.fieldChkedAt).format("YYYY-MM-DD HH:mm")}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.constantInspection.check.user')}</TableCell>
                          <TableCell align="center">{equipmentAlert.fieldChkUser}</TableCell>
                          <TableCell className="th" align="center">{t('message.common.subtitle.fllwActionType')}</TableCell>
                          <TableCell align="center">
                            {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O1_WAIT' && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType) && <div className="condition1">{getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)[0].title}</div>}
                            {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O2_OBSERVE' && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType) && <div className="condition3">{getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)[0].title}</div>}
                            {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O3_MNT' && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType) && <div className="condition5">{getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)[0].title}</div>}
                            {equipmentAlert.fllwActionType && equipmentAlert.fllwActionType === 'O4_NORMAL' && getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType) && <div className="condition6">{getEnumValueByEnumNameAndCode("FollowActionType", equipmentAlert.fllwActionType)[0].title}</div>}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  
                </>
  )
}

export default EquipmentAlertAndInspectionTable;